import { Geolocation } from 'ol';
import { triggerLoad } from './map.js';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import Style from 'ol/style/Style';
import CircleStyle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';

export function setupGeolocation(map) {
  const geolocation = new Geolocation({
    trackingOptions: { enableHighAccuracy: true },
    projection: map.getView().getProjection(),
    tracking: true,
  });

  const accuracyFeature = new Feature();
  geolocation.on('change:accuracyGeometry', function () {
    if (geolocation.getAccuracy() < 1000)
      accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
  });

  const positionFeature = new Feature();
  positionFeature.setStyle(
    new Style({
      image: new CircleStyle({
        radius: 6,
        fill: new Fill({ color: '#3399CC' }),
        stroke: new Stroke({ color: '#fff', width: 2 }),
      }),
    }),
  );

  let centred = false;
  geolocation.on('change:position', function () {
    const coordinates = geolocation.getPosition();
    positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
    if (coordinates && !centred) {
      centred = true;
      map.getView().setCenter(coordinates);
      triggerLoad();
    }
  });

  new VectorLayer({
    map,
    source: new VectorSource({ features: [accuracyFeature, positionFeature] }),
  });
}
